module.exports = __webpack_public_path__ + "static/media/logo.3b514095.svg";